<template>
  <BaseDialog
    v-model="showDialog"
    title="Filter"
    subtitle="Legg til filter"
    dialogIcon="mdi-filter-variant"
  >
    <template v-slot>
      <v-btn-toggle
        v-if="$vuetify.breakpoint.mobile"
        style="width: 50%"
        class="mb-4"
        mandatory
        color="primary"
        dense
      >
        <v-btn :to="{ name: 'Projects' }" block exact depressed>
          {{ isTrysilhus ? "Mine favoritter" : "Vis mine" }}
        </v-btn>

        <v-btn
          :to="{ name: 'Projects', query: { show: 'all' } }"
          exact
          block
          depressed
          value="all"
        >
          Vis alle
        </v-btn>
      </v-btn-toggle>

      <v-select
        v-model="type"
        :items="projTypes"
        filled
        label="Konsept"
        clearable
        item-text="name"
      ></v-select>

      <v-select
        v-model="status"
        :items="projectStatuses"
        filled
        chips
        class="textFont"
        clearable
        label="Status"
        multiple
      >
        <template v-slot:selection="{ attrs, item, select }">
          <v-chip
            v-bind="attrs"
            close
            class="textFont"
            @click="select"
            @click:close="remove(item)"
          >
            {{ item }}
          </v-chip>
        </template>
      </v-select>
    </template>
  </BaseDialog>
</template>

<script lang="ts">
import Vue from "vue";
import { mapGetters } from "vuex";

import BaseDialog from "@/components/shared/dialog/BaseDialog.vue";

export default Vue.extend({
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    projectStatuses: {},
    projTypes: {},
    selectedStatus: [],
    selectedProjType: {
      type: String,
    },
  },
  computed: {
    ...mapGetters({
      isTrysilhus: "shared/isTrysilhus",
      isMainContactPerson: "shared/isMainContactPerson",
      showAll: "tables/showAll",
    }),
    showDialog: {
      get(): boolean {
        return this.value;
      },
      set(value: boolean) {
        this.$emit("input", value);
      },
    },
    status: {
      get(): string[] {
        return this.selectedStatus as string[];
      },
      set(value: string[]) {
        this.$emit("update:selectedStatus", value);
      },
    },
    type: {
      get(): string {
        return this.selectedProjType;
      },
      set(value: string) {
        this.$emit("update:selectedProjType", value);
      },
    },
  },
  methods: {
    remove(item) {
      this.$emit("deleteStatus", item);
    },
  },
  components: {
    BaseDialog,
  },
});
</script>

<style lang="scss" scoped>
.textFont {
  .v-chip.v-size--default {
    border-radius: 16px;
    font-size: 16px;
    height: 32px;
  }
}
</style>
